module.exports = __webpack_public_path__ + "img/31-VEQCapital.a8aa6c0a.jpg";